// extracted by mini-css-extract-plugin
module.exports = {"createRecipe":"CreateRecipe_createRecipe__1UZjN","stageContainer":"CreateRecipe_stageContainer__13BJ9"};